export default "__VITE_PUBLIC_ASSET__f2510e1c__"